module.exports = __webpack_public_path__ + "img/lihat-mutasi-icon-active.4761f1bd.svg";